module.exports = __webpack_public_path__ + "img/postgre-dark.79b184cf.svg";